// extracted by mini-css-extract-plugin
export default {"photoBlock":"TypePhoto_photoBlock__XVCJN","textBlock":"TypePhoto_textBlock__nWbNJ","textContent":"TypePhoto_textContent__iMxHn"};